"use client"

import { X } from "lucide-react"
import { useEffect } from "react"
import "./css/image-modal.css"

const ImageModal = ({ isOpen, imagePath, title, onClose }) => {
  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "unset"
    }

    // Cleanup al desmontar el componente
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isOpen])

  // Cerrar modal con tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener("keydown", handleEscape)
    }

    return () => {
      document.removeEventListener("keydown", handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen || !imagePath) return null

  // Verificar si imagePath es un array (múltiples imágenes) o una sola imagen
  const isMultipleImages = Array.isArray(imagePath)

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <button className="image-modal-close" onClick={onClose}>
        <X size={24} />
      </button>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        {isMultipleImages ? (
          // Mostrar múltiples imágenes sin espacios
          <div className="image-modal-multiple">
            {imagePath.map((img, index) => (
              <img
                key={index}
                src={img || "/placeholder.svg"}
                alt={`${title} - Parte ${index + 1}`}
                className="image-modal-image-multiple"
              />
            ))}
          </div>
        ) : (
          // Mostrar una sola imagen (comportamiento original)
          <img src={imagePath || "/placeholder.svg"} alt={title} className="image-modal-image" />
        )}
      </div>
    </div>
  )
}

export default ImageModal
